import React from "react";

function ForwardArrow() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="12"
      
      viewBox="0 0 8 12"
    >
      <path
        
        d="M.59 10.59L5.17 6 .59 1.41 2 0l6 6-6 6-1.41-1.41z"
      ></path>
    </svg>
  );
}

export default ForwardArrow;